import { IForm } from 'core-components/classes/models/IForm'

export const classList = (...classes: any[]) =>
  classes.filter((i) => i && i.trim && !!i.trim()).join(' ')

export function createMap<T>(arr: T[], byKey: string): { [key: string]: T | undefined } {
  return arr.reduce((result, item) => {
    result[item[byKey]] = item
    return result
  }, {})
}

export const diffByKeys = (a: IForm, b: IForm, keys: string[]): string[] | null => {
  const result: string[] = []
  keys.forEach((key) => {
    if (a[key] !== b[key]) {
      result.push(key)
    }
  })
  return result.length ? result : null
}

/**
 * Merge list with second one (high priority) by some prop key
 * WARNING! without sort preserve
 * @param list1
 * @param list2
 * @param propKey
 */
export const mergeEntities = <T = IForm>(list1: T[], list2: T[], propKey: keyof T): T[] => {
  const obj: IForm = {}
  ;[...list1, ...list2].forEach((i) => (obj[i[propKey] as any] = i))
  return Object.keys(obj).map((k) => obj[k])
}

export const arrayIntersect = <T = any>(arr1: T[], arr2: T[]): T[] => {
  const s = new Set(arr2)
  return arr1.filter((x) => s.has(x))
}

export const arrayUnique = <T = any>(arr: T[]): T[] => {
  return Array.from(new Set(arr))
}

export const objectValues = <T = any>(obj: { [key: string]: T }): T[] => {
  return Object.keys(obj).map((k) => obj[k])
}

export const debounce = (fn: (...args: any[]) => void, ms = 0) => {
  let timeoutId: any
  return (...args: any[]) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => fn.call(null, ...args), ms)
  }
}

export const valueByPath = (obj: IForm, path: string[], def?: any): any => {
  return path.reduce((acc, prop) => acc[prop] || def, obj)
}

export const compose = (...fns: any[]) =>
  fns.reduce(
    (f, g) =>
      (...args: any[]) =>
        f(g(...args))
  )

export interface ICancelable<T> {
  promise: Promise<T>
  cancel: (...args: any[]) => void
}

export const makeCancelable = <T>(
  promise: Promise<T>,
  composeFunc?: (...args: any[]) => void
): ICancelable<T> => {
  let hasCanceled_ = false

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(
      (val) => (hasCanceled_ ? reject({ isCanceled: true }) : resolve(val)),
      (error) => (hasCanceled_ ? reject({ isCanceled: true }) : reject(error))
    )
  }) as Promise<T>

  return {
    promise: wrappedPromise,
    cancel() {
      if (composeFunc) {
        composeFunc()
      }
      hasCanceled_ = true
    },
  }
}
